import { formatDayLong } from "../utils/formatRelative";

export const describeScope = (
  tenantScope: string | null,
  landlordScope: string | null,
): string => {
  const parts = [
    tenantScope && `tenant ${tenantScope}`,
    landlordScope && `landlord ${landlordScope}`,
  ].filter(Boolean);
  return parts.length === 0
    ? "Applies to every project"
    : `Applies to projects with ${parts.join(" and ")}`;
};

export const describeAdded = (
  who: string | null | undefined,
  at: string | null | undefined,
): string | null => {
  const when = formatDayLong(at);
  if (!who && !when) return null;
  const byWho = who ? `Added by ${who}` : "Added";
  return when ? `${byWho}, ${when}` : byWho;
};

export const describeClient = (
  tenantScope: string | null,
  landlordScope: string | null,
): string =>
  [tenantScope && `tenant ${tenantScope}`, landlordScope && `landlord ${landlordScope}`]
    .filter(Boolean)
    .join(" and ") || "every client";

export const describeLoadFor = (
  loadFor: string[] | null,
  agentLabel: (agent: string) => string,
): string =>
  loadFor === null
    ? "Every agent reads or acknowledges it"
    : `Loaded in full for ${loadFor.map(agentLabel).join(", ")}; listed for other agents`;
